export const urlLanding = process.env.REACT_APP_LANDING_PAGE;
